import { render } from "./AlertsChart.vue?vue&type=template&id=51827240&scoped=true"
import script from "./AlertsChart.vue?vue&type=script&lang=js"
export * from "./AlertsChart.vue?vue&type=script&lang=js"

import "./AlertsChart.vue?vue&type=style&index=0&id=51827240&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51827240"]])

export default __exports__